import { LitElement, html, css, property, customElement } from 'lit-element';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';

interface BreadcrumbPath {
  name: string;
  action: () => void;
}

@customElement('breadcrumb-navigation')
export class BreadcrumbNavigation extends LitElement {
  @property({ type: Array }) paths: BreadcrumbPath[] = [];

  static styles = css`
    :host {
      display: inline-block;
    }
    .breadcrumb {
      display: flex;
      align-items: center; 
    }
    .breadcrumb a {
      text-decoration: underline;
      margin-right: 8px;   
      color: black; 
    }
    .breadcrumb span {
      margin-right: 8px;
      color: rgba(0, 115, 171, 1);
      font-weight: bold;
    }
    .breadcrumb .svg {
      padding: 0px 5px;
    }
  `;

  render() {
    return html`
      <nav class="breadcrumb">
        ${this.paths.map(
          (path, index) =>
            html`
              ${index < this.paths.length - 1
                ? html`<a href="#" @click=${() => this._navigate(index)}>${path.name}</a>
                <span class="svg">${SvgIcons.arrowRight}</span>`
                : html`<span>${path.name}</span>`}
            `
        )}
      </nav>
    `;
  }

  private _navigate(index: number) {
    this.paths[index].action();
  }
}
